<template>
  <div class="footer-container">
    <div class="footer-app">&copy; Copyright {{ thisYear }} Peak Pursuits. All rights reserved</div>
    <div class="footer-wrapper">
      <router-link to="/terms-of-use" class="router-item">Terms of Use</router-link>
      <router-link to="/privacy-policy" class="router-item">Privacy Policy</router-link>
      <a href="https://www.flaticon.com/authors/naive/flat?author_id=1167&type=sticker" target="_blank" class="router-item">Icons and Stickers by Flaticon</a>
    </div>
  </div>
</template>
<script>
export default {
  name: "BaseFnbFooter",
  computed: {
    thisYear(){
      const date = new Date();
			return date.getFullYear();
    }
  }
}
</script>
<style scoped lang="scss">
.footer-container {
	padding-inline: 24px;
  padding-block: 64px;
	display: flex;
  flex-direction: column;
	width: 100%;
	align-items: baseline;
	justify-content: space-between;
	gap: 32px;
	margin-top: auto;
  background: $green-dark;
  color: $white;
  .footer-app {
    text-align: center;
    margin-top: 32px;
  }
  .footer-wrapper {
    width: 100%;
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 48px;
    flex-wrap: wrap;
  }
  .router-item {
    text-decoration: underline;
    text-align: left;
    white-space: nowrap;
    color: $white;
    cursor: pointer;
    &:hover {
      color: $secondary-color-10;
    }
  }
}
@media (min-width: 672px) {
  .footer-app {
    margin-top: 0 !important;
    width: 100%;
  }
  .footer-wrapper {
    flex-direction: row !important;
    gap: 32px !important;
  }
}
</style>